import { PropsWithChildren } from "react";
import { Link } from "react-router-dom";

export const LinkContent = ({
  url,
  children,
  minHeight,
}: PropsWithChildren<{ url: string; minHeight?: number }>) => {
  return (
    <Link
      to={url}
      target="_self"
      style={{
        textDecoration: "none",
        color: "inherit",
        display: "flex",
        alignItems: "inherit",
        justifyContent: "inherit",
        width: "100%",
        height: "100%",
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <div
        style={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          width: "100%",
          minHeight: minHeight ? `${minHeight}px` : undefined,
          display: "flex",
          alignItems: "center",
        }}
      >
        {children}
      </div>
    </Link>
  );
};
